var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-theme-city vjs-fill",attrs:{"data-matomo-title":_vm.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }